import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/account.svg")